module.exports = __webpack_public_path__ + "static/media/The-Meadows-By-Laws.a1df6809.pdf";